import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { finalize, Observable } from 'rxjs';
import { features } from '@app/consts/features';
import { CustomReportsService } from '@app/modules/custom-reports/services/reports.service';
import { NewReportDialogComponent } from '../new-report-dialog/new-report-dialog.component';
import { ReportsService } from '../../services/reports.service';

@Component({
  selector: 'app-reports-rectangle-display-list',
  templateUrl: './reports-rectangle-display-list.component.html',
  styleUrls: ['./reports-rectangle-display-list.component.scss']
})
export class ReportsRectangleDisplayListComponent implements OnInit {
  reports$: Observable<any>;
  hardcodedReports: any[] = []
  public displayedColumns: string[] = ['name'];
  public features = features;
  isLoading: boolean;
  searchText = '';
  browseSectionTitle = 'Browse reports';
  adminActions = [
    {
      title: 'Manage reports',
      description: 'Review, edit and maintain report definitions.',
      icon: 'settings',
      action: () => this.goToReportsAdmin(),
      visible: true
    },
    // {
    //   title: 'Create custom report',
    //   description: 'Build a new report from scratch.',
    //   icon: 'add_circle',
    //   action: () => this.openNewReportDialog(),
    //   visible: true
    // }
  ];

  constructor(
    private reportsService: ReportsService,
    private router: Router,
    private customReportsService: CustomReportsService,
    private dialog: MatDialog,
  ) {
    this.reports$ = reportsService.getReports();
    this.getResports();
  }

  ngOnInit(): void {
  }

  getResports() {
    this.isLoading = true;
    this.reportsService.getReports()
      .pipe(
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe(
        res => {
          console.log(res);
          this.hardcodedReports = res;
          this.getCustomResports();
        }
      );
  }

  getCustomResports() {
    this.isLoading = true;
    this.customReportsService.getNewReports(100, 0, `Type.Id = "test-type"`)
      .pipe(
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe(
        res => {
          res.data.forEach((report: any) => {
            let index = this.hardcodedReports.findIndex((r: any) => r.id === report.id);
            if (index !== -1) {
              this.hardcodedReports[index].name = report.name;
            }
          });
        });
  }

  showMenu(id) {
    return id === 'ReportOrganizationalChart' || id === 'ReportPositionChart';
  }

  openNewReportDialog() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.minWidth = 1200;

    this.dialog.open(NewReportDialogComponent, dialogConfig);
  }

  goToEditReport(id: string) {
    this.router.navigate([`Reports/Builder/Edit/${id}`]);
  }

  goToReportsAdmin() {
    this.router.navigate(['Reports/Admin']);
  }

  // Filters the report tiles by name as the user types
  filterReports(reports: any[]) {
    if (!reports) {
      return [];
    }

    const term = this.searchText.trim().toLowerCase();

    if (!term) {
      return reports;
    }

    return reports.filter(report => (report.name || '').toLowerCase().includes(term));
  }
}